import { css } from "styled-components";

export const typography = {
  header1: css`
    font-family: "Lato", sans-serif;
    font-weight: 500;
    font-size: 32px;
    line-height: 48px;
  `,
  header2: css`
    font-family: "Lato", sans-serif;
    font-weight: 400;
    font-size: 28px;
    line-height: 40px;
  `,
  header3: css`
    font-family: "Lato", sans-serif;
    font-weight: 400;
    font-size: 24px;
    line-height: 40px;
  `,
  header4: css`
    font-family: "Lato", sans-serif;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
  `,
  header5: css`
    font-family: "Lato", sans-serif;
    font-weight: 300;
    font-size: 20px;
    line-height: 24px;
  `,
  header6: css`
    font-family: "Lato", sans-serif;
    font-size: 42px;
    font-weight: 500;
    line-height: 48px;
  `,
  subtitle1: css`
    font-family: "Lato", sans-serif;
    font-weight: 400;
    font-size: 17px;
    line-height: 24px;
  `,
  subtitle2: css`
    font-family: "Lato", sans-serif;
    font-weight: 500;
    font-size: 17px;
    line-height: 24px;
  `,
  subtitle3: css`
    font-family: "Lato", sans-serif;
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
  `,
  subtitle4: css`
    font-family: "Lato", sans-serif;
    font-weight: 500;
    font-size: 15px;
    line-height: 24px;
  `,
  subtitle5: css`
    font-family: "Lato", sans-serif;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  `,
  body1: css`
    font-family: "Lato", sans-serif;
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
  `,
  body2: css`
    font-family: "Lato", sans-serif;
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
  `,
  body3: css`
    font-family: "Lato", sans-serif;
    font-weight: 300;
    font-size: 13px;
    line-height: 20px;
  `,
  body4: css`
    font-family: "Lato", sans-serif;
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    font-style: italic;
  `,
  body5: css`
    font-family: "Lato", sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
  `,
  smallText1: css`
    font-family: "Lato", sans-serif;
    font-weight: 400;
    font-size: 11px;
    line-height: 16px;
  `,
  smallText2: css`
    font-family: "Lato", sans-serif;
    font-weight: 500;
    font-size: 11px;
    line-height: 16px;
  `,
  smallText3: css`
    font-family: "Lato", sans-serif;
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
  `,
  smallText4: css`
    font-family: "Lato", sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
  `,
  smallText5: css`
    font-family: "Lato", sans-serif;
    font-size: 10px;
    font-weight: 500;
  `,
  buttonsText: css`
    font-family: "Lato", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
  `,
  buttonsText2: css`
    font-family: "Lato", sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
  `,
  menuText: css`
    font-family: "Lato", sans-serif;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
  `,
};

const fontsStyles = css``;

export default fontsStyles;
